import { useAxios } from "@/compositions";
import type { LocationsQuery, LocationsResponse } from "./types.ts";

const MODEL = "locations";

const { axiosInstance } = useAxios(`${import.meta.env.VITE_API_BASE_URL}/v1/`);

/** Repeats array params (`code=a&code=b`) instead of axios' default `code[]=a`. */
const serializeParams = (params: LocationsQuery): string => {
  const search = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    (Array.isArray(value) ? value : [value]).forEach((v) => search.append(key, String(v)));
  });
  return search.toString();
};

export default {
  getAll: async (params: LocationsQuery = {}): Promise<LocationsResponse> => {
    const query = serializeParams(params);
    const response = await axiosInstance.get(query ? `${MODEL}?${query}` : MODEL);
    return response.data;
  }
};
